import { useMemo } from 'react'

import { useTokenCatalog } from '@/data/marketApi/hooks/useTokenCatalog'

import { Currency } from '../../sdk'

import { resolveSwapCurrencyFromCatalog } from './swapCatalog'
import { useSwapCatalogChainId } from './useSwapCatalogChainId'

/** Resuelve un id de moneda contra el catálogo de producto. */
export function useResolveSwapCurrency(currencyId: string | undefined): Currency | undefined {
  const chainId = useSwapCatalogChainId()
  const { entries } = useTokenCatalog()

  return useMemo(
    () => resolveSwapCurrencyFromCatalog(chainId, currencyId, entries),
    [chainId, currencyId, entries],
  )
}
